
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authenticate",
      function () {
        return require("private-next-pages/authenticate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authenticate"])
      });
    }
  